import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { withRouter } from 'react-router-dom';
import $cookie from 'js-cookie';
import ypRequest from '@utils/ypRequest/';
import ypRequest2 from '@utils/ypRequest2/';
import initGeetest from './geetest.js';
import TrackEvent from './trackEvent';
import './style.normal.less';

const getSearch = (search: any) => {
  const searchObj = search.replace('?', '');
  if (searchObj) {
    return searchObj.split('&').reduce((pre: any, next: any) => {
      const [key, value] = next.split('=');
      return {
        ...pre,
        [key]: value,
      };
    }, {});
  } else {
    return {};
  }
};

const Login = (props: any) => {
  const {
    location: { origin, search },
  }: Window = window;
  const searchObj = getSearch(search);

  let [captchaObj, SetCaptchaObj] = useState(null);
  let [count, setCount] = useState(60);
  let [isSend, setIsSend] = useState(false);
  let [mobile, setMobile] = useState(''); // TODO: 临时设置，上线移除
  let [result, setResult] = useState(null);
  let [isSuccess, setSuccess] = useState(false);
  let [verifyCode, setVerifyCode] = useState('');
  let [captchaSuccess, setCaptchaSuccess] = useState(false);
  let [captchaTicket, setCaptchaTicket] = useState('');
  let [captchaRandstr, setCaptchaRandstr] = useState('');

  useEffect(() => {
    if (JSON.stringify(searchObj) !== '{}') {
      searchObj?.code && loginATrust(searchObj?.code);
    }
    initTencentCaptcha()
  }, []);

  const initTencentCaptcha = () => {
    const script = document.createElement('script');
    script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      console.log('TencentCaptcha SDK loaded');
    };

    return () => {
      document.head.removeChild(script);
    };
  }

  const callback = (res:any) => {
    console.log('Verification callback:', res);

    if (res.ret === 0) {
      setCaptchaSuccess(true)
      setCaptchaTicket(res.ticket)
      setCaptchaRandstr(res.randstr)
    }
  };

  useEffect(() => {
    if (captchaSuccess && captchaTicket && captchaRandstr) {
      sendCode();
    }
  }, [captchaSuccess, captchaTicket, captchaRandstr]);

  const loadErrorCallback = () => {
    const appid = '199001991'; // 请替换为实际的 AppID
    const ticket = `terror_1001_${appid}_${Math.floor(new Date().getTime() / 1000)}`;
    callback({
      ret: 0,
      randstr: `@${Math.random().toString(36).substr(2)}`,
      ticket: ticket,
      errorCode: 1001,
      errorMessage: 'jsload_error',
    });
  };

  const showTencentCaptcha = () => {
    try {
      if (window.TencentCaptcha) {
        const captcha = new window.TencentCaptcha('199001991', callback, {});
        captcha.show();
      } else {
        console.error('TencentCaptcha SDK not loaded.');
        loadErrorCallback();
      }
    } catch (error) {
      console.error('Error creating TencentCaptcha instance:', error);
      loadErrorCallback();
    }
  };

  const verifyCodeFunc = (e: any) => {
    const value = e.target.value.trim().replace(/[^0-9]/g, '');
    setVerifyCode(value);
  };
  const setMobileFunc = (e: any) => {
    const value = e.target.value.trim().replace(/[^0-9]/g, '');
    setMobile(value);
  };
  const checkMobile = () => {
    let reg = /^1((3[\d])|(4[5,6,7,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[\d])|(9[0-9]))\d{8}$/;
    // //console.log(reg.test(this.form.login))
    if (!mobile) {
      message.error('请先输入手机号');
      return false;
    } else {
      if (!reg.test(mobile)) {
        message.error('请输入正确的手机号');
        return false;
      } else {
        return true;
      }
    }
  };
  const sendCodeClick = async () => {
    const flag = checkMobile();
    if (flag) {
      setCaptchaSuccess(false)
      setCaptchaTicket("")
      setCaptchaRandstr("")
      showTencentCaptcha();
    }
  };

  const sendCode = async () => {
    const apiUrl = '/user/sms/sendVerifyCode';
    const flag = checkMobile();
    console.log("captchaSuccess:" + captchaSuccess)
    if (flag) {
      if (captchaSuccess) {
        const header = {
          'X-YPSX-CAPTCHA-TICKET': captchaTicket,
          'X-YPSX-CAPTCHA-NONCE': captchaRandstr
        };
        try {
          const dataVal = { mobile: mobile, bizId: 'login' };
          const res: any = await ypRequest2(apiUrl, dataVal, header);
          if (res.success) {
            message.success('短信发送成功');
            setIsSend(true);
          }
        } catch (error) {}
      } else {
        message.error('请先验证身份');
      }
    }
  }
  const onBlurFunc = () => {
    checkMobile();
  };

  const loginATrust = async (code: string) => {
    const myEnv = process.env.REACT_APP_MY_ENV || 'prod';
    const res: any = await ypRequest('tenant.LoginService.loginWithATrust', {
      // appId: $cookie.get('appId') || '',
      appId:
        myEnv === 'sit'
          ? 'fcf83fbc-49fa-42c7-9f22-0adc0860e3e8'
          : myEnv === 'pre'
          ? '3b4b8d1b-f401-4688-8905-4f8328eb12be'
          : '20b89ba3-a239-4d34-9666-d46fac789520',
      code,
    });
    if (res.success) {
      handleLogin(res);
      // $cookie.remove('appId');
    }
  };

  const loginFunc = async () => {
    if (mobile && verifyCode) {
      try {
        const apiUrl = 'tenant.loginService.mobileLogin';
        const dataVal = { mobile: mobile, role: 1, verifyCode: verifyCode };
        const res: any = await ypRequest(apiUrl, dataVal);
        if (res.success) {
          handleLogin(res);
        }
      } catch (error) {}
    } else {
      message.error('请输入完整信息');
    }
  };
  const handleLogin = (res: any) => {
    const { result } = res;
    let host = '';
    const myEnv = process.env.REACT_APP_MY_ENV || 'prod';
    if (!myEnv || myEnv === 'prod') {
      if (window.location.host === 'prod-tyuan-login.ypsx-internal.com') {
        host = 'ypsx-internal.com';
      } else {
        host = 'ypshengxian.com';
      }
    } else {
      host = 'ypsx-internal.com';
    }

    $cookie.set('env', myEnv, {
      domain: `.${host}`,
      path: '/',
      expires: 30,
    });
    $cookie.set('token', result.token, {
      domain: `.${host}`,
      path: '/',
      expires: 30,
    });
    // $cookie.set('tenantId', result.user?.tenantId, {
    //   domain: `.${host}`,
    //   path: '/',
    //   expires: 30,
    // });
    $cookie.set('mobile', result.user?.mobile, {
      domain: `.${host}`,
      path: '/',
      expires: 30,
    });
    message.success('登录成功');
    jumpUrl();
    if (myEnv === 'prod') {
      TrackEvent(
        result.token,
        result.employee.mobile,
        result.employee.tenantId,
        myEnv
      );
    }
  };
  const jumpUrl = () => {
    let path = '';
    const myEnv = process.env.REACT_APP_MY_ENV || '';

    if (!myEnv || myEnv === 'prod') {
      if (window.location.host === 'prod-tyuan-login.ypsx-internal.com') {
        path = `https://prod-tyuan.ypsx-internal.com/?rt=${new Date().getTime()}`;
      } else {
        path = `https://tyuan.ypshengxian.com/?rt=${new Date().getTime()}`;
      }
    } else {
      // 测试 开发 预发
      path = `https://${myEnv}-tyuan.ypsx-internal.com/?rt=${new Date().getTime()}`;
    }

    if (path) {
      setTimeout(() => {
        window.location.href = path;
      }, 1000);
    }
  };

  const getLoginATrustConfig = async () => {
    const res: any = await ypRequest(
      'tenant.LoginService.getLoginATrustConfig'
    );
    if (res.success) {
      const { result } = res;
      // $cookie.set('appId', result?.appId);
      if (result.config === 2) {
        window.location.href = `https://svpn.ypshengxian.com/passport/v1/public/auth2ssoLogin?redirectUrl=${encodeURIComponent(
          origin
        )}&appid=${result?.appId}&responseType=code`;
      }
    }
  };

  useEffect(() => {
    let timer: any;
    if (isSend && count !== 0) {
      timer = setInterval(() => {
        // 这时候的num由于闭包的原因，一直是0，所以这里不能用setNum(num-1)
        setCount((n) => {
          if (n === 0) {
            // console.log(n);
            setIsSend(false);
            setCount(60);
            clearInterval(timer);
          }
          return n - 1;
        });
      }, 1000);
    } else {
      setIsSend(false);
      setCount(60);
    }
    return () => {
      // 组件销毁时，清除定时器
      clearInterval(timer);
    };
  }, [count, isSend]);
  return (
    <div className="loginPage" style={{}}>
      <div className="centerWhite">
        <div id="applogin">
          <div className="himg"></div>
          <div className="wz1">欢迎来到谊品中台管理系统</div>
          <div className="formPart">
            <div className="inputPart">
              <div className="ripart">
                <input
                  onBlur={onBlurFunc}
                  type="text"
                  onChange={setMobileFunc}
                  placeholder="请输入手机号"
                  className="cominput"
                  value={mobile}
                  maxLength={11}
                />
              </div>
            </div>
            <div className="inputPart pr">
              <div className="ripart flex1">
                <input
                  type="text"
                  onChange={verifyCodeFunc}
                  placeholder="请输入验证码"
                  className="cominput"
                  value={verifyCode}
                  maxLength={6}
                />
              </div>

              {isSend ? (
                <div className="hpo hpo2">{count}s后重新获取</div>
              ) : (
                <div className="hpo" onClick={sendCodeClick}>
                  获取验证码
                </div>
              )}
            </div>
          </div>
          <div className="bottomBtn" onClick={loginFunc}>
            确认登录
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Login);
